<template>
  <div class="meeting-data-view">
    <div class="content-top" v-loading="isTopLoading">
      <div class="filter-content">
        <el-form inline>
          <el-form-item label="时间选择:">
            <el-date-picker
              v-model="meetingStatDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyyMMdd"
              :editable="false"
            />
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="getOverViewData">筛选</el-button>
      </div>
      <div class="data-overview-box">
        <div v-for="item in overViewData" :key="item.key" class="data-item">
          <div class="data-item-info">
            <div class="data-from-label">{{ item.label }}</div>
            <div class="data-from-number">
              <span class="data-num">{{ item.data !== null ? item.data : '--' }}</span>
              <span class="data-prefix">{{ item.unit || '' }}{{ item.appendText || '' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="lineBg" />
    <div class="grey-gap" />
    <div class="content-table" v-loading="isLoading">
      <el-form :inline="true" :model="form">
        <el-form-item label="会议类型">
          <el-select
            v-model="form.type"
            placeholder="请选择"
            clearable
            @change="formChange({ key: 'type', value: form.type })"
          >
            <el-option
              v-for="item in meetingTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="会议产品">
          <el-select
            v-model="form.product_ids"
            :clearable="true"
            multiple
            placeholder="请选择会议相关产品"
            @change="formChange({ key: 'product_ids', value: form.product_ids })"
          >
            <el-option
              v-for="item in productList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="地区">
          <el-select
            v-model="form.province_code"
            :clearable="true"
            placeholder="省"
            style="margin-right: 12px"
            @change="formChange({ key: 'province_code', value: form.province_code })"
          >
            <el-option
              v-for="item in provinceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-select
            v-model="form.city_code"
            :clearable="true"
            placeholder="市"
            @change="formChange({ key: 'city_code', value: form.city_code })"
          >
            <el-option
              v-for="item in cityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :inline="true" :model="form">
        <el-form-item label="查询日期">
          <el-date-picker
            v-model="form.date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyyMMdd"
            @change="formChange({ key: 'date', value: form.date })"
          />
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="clickToFilterTableList">筛选</el-button>
          <ExportExcel
            config-name="MeetingDataEveryDay"
            :excel-data="excelData"
            :is-loading="isExportLoading"
            @emit="handleExportExcel"
          ></ExportExcel>
        </el-form-item>
      </el-form>
      <div>
        <el-table class="my-table" :data="tableData" style="width: 100%">
          <template slot="empty">
            <!-- 没有数据 -->
            <NoData></NoData>
          </template>
          <el-table-column prop="date" label="日期">
            <template slot-scope="scope">
              {{ dateFormat(new Date(scope.row.date), 'YYYY-MM-dd') }}
            </template>
          </el-table-column>
          <el-table-column prop="apply_num" label="计划会议数" />
          <el-table-column prop="finish_num" label="完成会议数" />
          <el-table-column prop="average_duration" label="平均时长(min)">
            <template slot-scope="scope">
              {{ formatSecondsToMin(scope.row.average_duration) }}
            </template>
          </el-table-column>
          <el-table-column prop="attending_num" label="参会总人数" />
          <el-table-column prop="average_num" label="参会平均人数" />
          <el-table-column prop="violate_num" label="违规数" />
          <el-table-column prop="online_percent" label="线上会议占比">
            <template slot-scope="scope">{{ scope.row.online_percent }}%</template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click.native.prevent="clickToDetail(scope.row)">
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="pagination"
          :current-page.sync="pagination.page_index"
          :page-size="pagination.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="g_pageSizesConfig"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getMeetingStatPagesApi, getMeetingStatByDayApi } from '@/api/dataCenter.js';
import { dateFormat } from '@/utils/time.js';
import { getAreaList } from '@/api/setUp';
import { formatSecondsToMin } from '@/utils/util';
import NoData from '@/components/no-data';
import ExportExcel from '@/components/export-excel';
export default {
  name: 'MeetingData',
  // directives: {},
  // filters: {},
  // props: [],
  components: {
    NoData,
    ExportExcel,
  },
  data() {
    return {
      formatSecondsToMin,
      dateFormat,
      isTopLoading: false,
      form: {
        type: '',
        product_ids: [],
        province_code: '',
        city_code: '',
        date: '',
      },
      pagination: {
        page_size: this.g_pageSizeDefault,
        page_index: 1,
      },
      total: 0,
      meetingStatDate: [],
      // productList: [], // 产品列表
      // provinceList: [], // 省数据
      cityList: [], // 市数据
      overViewData: [
        {
          label: '科室会数量（线上会占比）',
          key: 'department_num',
          data: '--',
          unit: '场',
          appendText: '(--%)',
        },
        {
          label: '城市会数量（线上会占比）',
          key: 'city_num',
          data: '--',
          unit: '场',
          appendText: '(--%)',
        },
        {
          label: 'AB类医生参会占比',
          key: 'AB_percent',
          data: '--',
        },
        {
          label: '讲者平均讲课次数',
          key: 'ave_speak_num',
          data: '--',
          unit: '次',
        },
      ],
      isLoading: false,
      tableData: [],
      excelData: [],
      isExportLoading: false,
    };
  },
  computed: {
    meetingTypeOptions() {
      return this.$store.state.meetingData.meetingTypeOptions;
    },
    productList() {
      return this.$store.state.meetingData.productList;
    },
    provinceList() {
      return this.$store.state.meetingData.provinceList;
    },
  },
  watch: {},
  // beforeCreate() {},
  created() {
    this.pagination.page_size = this.g_pageSizeDefault;
    this.init();
  },
  // beforeMount() {},
  mounted() {},
  // beforeUpdate() {},
  // updated() {},
  // beforeDestroy() {},
  // destroyed() {},
  methods: {
    init() {
      this.getOverViewData();
      // this.getMeetingTypeList();
      this.$store.dispatch('meetingData/getMeetingTypeList');
      // this.getProductList();
      this.$store.dispatch('meetingData/getProductList');
      // this.getProvinceData();
      this.$store.dispatch('meetingData/getProvinceData');
      this.getTableData();
    },
    // 获取占比统计数据
    async getOverViewData() {
      this.isTopLoading = true;
      const params = {
        start_date:
          this.meetingStatDate && this.meetingStatDate.length ? this.meetingStatDate[0] : '',
        end_date:
          this.meetingStatDate && this.meetingStatDate.length ? this.meetingStatDate[1] : '',
      };
      try {
        const res = await getMeetingStatPagesApi(params);
        if (Object.keys.length) {
          this.overViewData = this.overViewData.reduce((arr, item, index) => {
            const items = item;
            if (item.key === 'AB_percent') {
              items.data = `${res[item.key]}%`;
            } else {
              items.data = res[item.key];
            }

            if (item.key === 'department_num') {
              items.appendText = `(${res.department_online_percent}%)`;
            }
            if (item.key === 'city_num') {
              items.appendText = `(${res.city_online_percent}%)`;
            }
            arr[index] = items;
            return arr;
          }, []);
        }
      } catch (err) {
        this.overViewData = this.overViewData.reduce((arr, item, index) => {
          const items = item;
          items.data = null;
          if (item.key === 'department_num') {
            items.appendText = `(--%)`;
          }
          if (item.key === 'city_num') {
            items.appendText = `(--%)`;
          }
          arr[index] = items;
          return arr;
        }, []);
        console.log('error', err);
      }
      this.isTopLoading = false;
    },
    // 获取会议类型列表
    // async getMeetingTypeList() {
    //   try {
    //     const res = await getMeetingTypeListApi();
    //     this.meetingTypeOptions = res.data.map((item) => ({
    //       label: item.name,
    //       value: item.value,
    //     }));
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },

    // 获取产品标签
    // async getProductList() {
    //   try {
    //     const res = await getProductListApi();
    //     this.productList = res.data.map((item) => ({
    //       label: item.product_name,
    //       value: item.product_id,
    //     }));
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    // async getProvinceData() {
    //   try {
    //     const res = await getAreaList({
    //       type: 'Province',
    //     });
    //     console.log('省数据', res);
    //     this.provinceList = res.data.map((item) => ({
    //       label: item.area_name,
    //       value: item.area_code,
    //     }));
    //   } catch (err) {
    //     console.log('error', err);
    //   }
    // },
    async getCityData(area_code = '') {
      if (this.form.province_code === '') {
        this.cityList = [];
        return;
      }
      try {
        const res = await getAreaList({
          area_code,
          type: 'City',
        });
        // console.log('市数据', res);

        this.cityList = res.data.map((item) => ({
          label: item.area_name,
          value: item.area_code,
        }));
      } catch (err) {
        console.log('error', err);
      }
      //   console.log("市数据", data);
    },
    formChange({ key, value }) {
      if (key === 'province_code') {
        this.form.city_code = '';
        this.getCityData(value);
      }
    },
    /** 点击筛选 */
    clickToFilterTableList() {
      this.pagination.page_index = 1;
      this.getTableData();
    },
    // 获取表格数据
    async getTableData() {
      this.isLoading = true;
      const params = {
        province_code: this.form.province_code,
        city_code: this.form.city_code,
        start_date: this.form.date?.length ? this.form.date[0] : '',
        end_date: this.form.date?.length ? this.form.date[1] : '',
        ...this.pagination,
        product_ids: this.form.product_ids,
        type: this.form.type || 0,
      };
      try {
        const res = await getMeetingStatByDayApi(params);
        this.tableData = res.data;
        this.total = res.total_num;
      } catch (err) {
        this.tableData = [];
        this.total = 0;
        this.$message.error(`查询会议每日统计列表失败 ${err.message || ''}`);
        console.log('error', err);
      }
      this.isLoading = false;
    },
    async handleExportExcel() {
      this.isExportLoading = true;
      const params = {
        province_code: this.form.province_code,
        city_code: this.form.city_code,
        start_date: this.form.date?.length ? this.form.date[0] : '',
        end_date: this.form.date?.length ? this.form.date[1] : '',
        product_ids: this.form.product_ids,
        type: this.form.type || 0,
        page_size: 50000,
        page_index: 1,
      };
      try {
        const res = await getMeetingStatByDayApi({
          page_index: 1,
          page_size: 1,
          ...params,
        });
        if (res.total_num > 50000) {
          this.$message.warning(`最大支持导出5万条数据，当前数据${res.total_num}条，请重新筛选`);
          this.isExportLoading = false;
        } else {
          const res = await getMeetingStatByDayApi({
            page_index: 1,
            page_size: 50000,
            ...params,
          });
          this.excelData = res.data.map((item) => {
            const items = { ...item };
            items.date = this.dateFormat(new Date(item.date), 'YYYY-MM-dd');
            items.average_duration = this.formatSecondsToMin(item.average_duration);
            items.online_percent = `${item.online_percent}%`;
            return items;
          });
        }
      } catch (err) {
        this.$message.error(err);
        console.log('error', err);
      }
      this.isExportLoading = false;
    },
    // 查看详情
    clickToDetail(row) {
      this.g_tourl(`/saas/meetingData/meetingDetail.html?date=${row.date}`, {
        open: true,
      });
    },
    handleCurrentChange(val) {
      this.pagination.page_index = val;
      this.getTableData();
    },
    handleSizeChange(size) {
      this.pagination.page_size = size;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.meeting-data-view {
  .content-top {
    .filter-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eee;
      height: 68px;
      .el-form-item {
        margin-bottom: 0;
      }
    }
    .data-overview-box {
      width: 100%;
      display: flex;
      margin: 24px 0px;
      box-sizing: border-box;
      .data-item {
        flex: 1;
        height: 128px;
        background: #f7f9fc;
        border: 1px solid #2f96ff;
        border-radius: 4px;
        border-top-width: 8px;
        margin-right: 16px;
        .data-item-info {
          padding-top: 28px;
          padding-left: 24px;
          box-sizing: border-box;
          .data-from-label {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #313233;
            line-height: 24px;
          }
          .data-from-number {
            .data-num {
              font-family: PingFangSC-Medium;
              font-size: 30px;
              color: #2f96ff;
            }
            .data-prefix {
              font-family: PingFangSC-Medium;
              font-size: 14px;
              color: #2f96ff;
              padding-left: 8px;
            }
          }
        }
      }
    }
  }
  .lineBg {
    width: 100%;
    height: 24px;
    background-color: rgba(0, 0, 0, 0.04);
  }
  .content-table {
    padding-top: 12px;
  }
  .pagination {
    float: right;
    margin-top: 12px;
  }
}
</style>
